// extracted by mini-css-extract-plugin
module.exports = {"about-us-container":"AboutUs_about-us-container__3BRb6","container":"AboutUs_container__VhK3r"};